import { Link } from "react-router-dom";
import { Phone } from "lucide-react";

// AI.Prof contact number — matches the footer "Get in Touch".
export const AIPROF_PHONE = "+918071580580";

/**
 * Device-aware "Contact Us" call-to-action.
 *
 *  - Phones / small screens (below lg) → opens the dialpad (tel:) with the
 *    AI.Prof number, so a tap dials straight away.
 *  - Laptop / desktop (lg and up) → opens the /RFC/guidance contact form.
 *
 * `className` should carry only the visual styling (colors, padding, radius,
 * gaps, etc.). The display utility (`inline-flex` / `hidden`) is managed here
 * so exactly one variant renders per device — don't pass `inline-flex`/`hidden`.
 */
export default function ContactCTA({
  className = "",
  iconClassName = "w-5 h-5",
  label = "Talk to our Expert",
}) {
  const content = (
    <>
      <Phone className={iconClassName} />
      {label}
    </>
  );

  return (
    <>
      {/* Mobile / tablet → dialpad */}
      <a href={`tel:${AIPROF_PHONE}`} className={`inline-flex lg:hidden ${className}`}>
        {content}
      </a>
      {/* Laptop / desktop → contact form */}
      <Link
        to="/RFC/guidance"
        target="_blank"
        rel="noopener noreferrer"
        className={`hidden lg:inline-flex ${className}`}
      >
        {content}
      </Link>
    </>
  );
}
